import { motion } from 'motion/react';

const TeamsLights = () => {
  return (
    <svg
      width='657'
      height='541'
      viewBox='0 0 657 541'
      className='absolute left-1/2 top-full -z-10 -translate-x-1/2 -translate-y-[20%] opacity-80 md:-translate-y-[75%]'
    >
      <motion.g
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.75, delay: 0.3, type: 'spring' }}
        filter='url(#paint_light_1)'
      >
        <path d='M334 114.801V517L647 229.5V62H334V114.801Z' fill='url(#paint_light_11)' />
      </motion.g>
      <motion.g
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.75, delay: 0.5, type: 'spring' }}
        filter='url(#paint_light_2)'
      >
        <path d='M323 114.801V517L10 229.5V62H323V114.801Z' fill='url(#paint_light_22)' />
      </motion.g>
      <motion.g
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.75, delay: 0.7, type: 'spring' }}
        filter='url(#paint_light_3)'
      >
        <path d='M163 10L327.962 531L488 10H163Z' fill='url(#paint_light_33)' />
      </motion.g>
      <defs>
        <filter
          id='paint_light_1'
          x='324'
          y='52'
          width='333'
          height='475'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='5' result='effect1_foregroundBlur_588_71292' />
        </filter>
        <filter
          id='paint_light_2'
          x='0'
          y='52'
          width='333'
          height='475'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='5' result='effect1_foregroundBlur_588_71292' />
        </filter>
        <filter
          id='paint_light_3'
          x='153'
          y='0'
          width='345'
          height='541'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='5' result='effect1_foregroundBlur_588_71292' />
        </filter>
        <linearGradient
          id='paint_light_11'
          x1='490.5'
          y1='62'
          x2='490.5'
          y2='540.679'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.119792' stopColor='#33EB93' stopOpacity='0' />
          <stop offset='1' stopColor='#EFF0BC' stopOpacity='0.33' />
        </linearGradient>
        <linearGradient
          id='paint_light_22'
          x1='166.5'
          y1='62'
          x2='166.5'
          y2='540.679'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.119792' stopColor='#C237D9' stopOpacity='0' />
          <stop offset='1' stopColor='#EFF0BC' stopOpacity='0.33' />
        </linearGradient>
        <linearGradient
          id='paint_light_33'
          x1='323.53'
          y1='10'
          x2='323.53'
          y2='527.835'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.119792' stopColor='#F0F426' stopOpacity='0' />
          <stop offset='1' stopColor='#EFF0BC' stopOpacity='0.33' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default TeamsLights;
